/**
 * @generated SignedSource<<e35dbe6ac632190b9fd6b810aa1396fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateThreadReactionInput = {
  reaction: string;
  referenceId: string;
};
export type ReactionButton_chat_createSocialThreadReaction_Mutation$variables = {
  input: CreateThreadReactionInput;
};
export type ReactionButton_chat_createSocialThreadReaction_Mutation$data = {
  readonly createThreadReaction: {
    readonly conversation: {
      readonly id: string;
    };
    readonly deletedAt: ISO8601DateTimeString | null;
    readonly id: string;
    readonly senderId: string | null;
    readonly text: UnknownJSON;
  };
};
export type ReactionButton_chat_createSocialThreadReaction_Mutation = {
  response: ReactionButton_chat_createSocialThreadReaction_Mutation$data;
  variables: ReactionButton_chat_createSocialThreadReaction_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Message",
    "kind": "LinkedField",
    "name": "createThreadReaction",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "senderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReactionButton_chat_createSocialThreadReaction_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReactionButton_chat_createSocialThreadReaction_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "6ee2c80971cd9f1623ea8f5fb2390525",
    "id": null,
    "metadata": {},
    "name": "ReactionButton_chat_createSocialThreadReaction_Mutation",
    "operationKind": "mutation",
    "text": "mutation ReactionButton_chat_createSocialThreadReaction_Mutation(\n  $input: CreateThreadReactionInput!\n) {\n  createThreadReaction(input: $input) {\n    id\n    text\n    senderId\n    deletedAt\n    conversation {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "92ea5bf2272743e97b4931706e9dc811";

export default node;
